// 本月大瓜 · 单页演示数据
// 说明：内容聚焦行业热点与话题热议，围绕娱乐/文娱动态展开盘点。

export const navItems = [
  { id: "overview", label: "本月总览" },
  { id: "rank", label: "热度榜单" },
  { id: "feed", label: "分类吃瓜" },
  { id: "timeline", label: "全记录" },
  { id: "featured", label: "热门专题" },
  { id: "faq", label: "吃瓜指南" },
  { id: "about", label: "关于我们" },
];

export const heroStats = [
  { value: "128", unit: "件", label: "本月追踪事件" },
  { value: "96.8", unit: "万", label: "峰值互动热度" },
  { value: "47", unit: "条", label: "热搜上榜话题" },
  { value: "6", unit: "小时", label: "榜单刷新间隔" },
];

export const rankList = [
  { rank: 1, title: "年度爆款续集官宣全员回归，定档消息引爆热搜", tag: "影视剧", heat: 96.8, delta: "0", period: "连续 5 天居首" },
  { rank: 2, title: "顶流歌手新专辑三平台霸榜，预售纪录刷新", tag: "音乐", heat: 91.2, delta: "+3", period: "今日上升 3 位" },
  { rank: 3, title: "老牌综艺换阵容引争议，观众吵上热搜", tag: "综艺", heat: 84.5, delta: "-1", period: "讨论持续升温" },
  { rank: 4, title: "顶流跨界成立个人工作室，粉丝平台狂欢", tag: "商业", heat: 78.9, delta: "+2", period: "新进前十" },
  { rank: 5, title: "头部球会主帅下课，转会传闻满天飞", tag: "体坛", heat: 73.4, delta: "-1", period: "关注度走高" },
  { rank: 6, title: "都市情感剧口碑逆袭，收视率一路走高", tag: "影视剧", heat: 67.7, delta: "+1", period: "口碑发酵" },
  { rank: 7, title: "音乐节官宣重磅阵容，开票即秒罄", tag: "音乐", heat: 62.1, delta: "-2", period: "话题回落中" },
  { rank: 8, title: "选秀复盘综艺开播，导师阵容全公开", tag: "综艺", heat: 55.6, delta: "+1", period: "新晋上榜" },
  { rank: 9, title: "知名连锁品牌明星代言人更替引热议", tag: "商业", heat: 48.9, delta: "0", period: "保持热度" },
  { rank: 10, title: "国手归队备战大赛，官方发布集训名单", tag: "体坛", heat: 42.3, delta: "+4", period: "快速蹿升" },
];

export const categories = [
  { key: "drama", label: "影视剧", desc: "剧集、电影上映与口碑动向" },
  { key: "show", label: "综艺", desc: "热门综艺阵容与节目话题" },
  { key: "music", label: "音乐", desc: "发歌、演唱会与榜单动态" },
  { key: "business", label: "商业", desc: "明星商务与品牌合作动向" },
  { key: "sports", label: "体坛", desc: "赛场内外热点人物与事件" },
];

export const feedItems: Record<string, Array<{ title: string; tag: string; hot: number; time: string; summary: string }>> = {
  drama: [
    { title: "古装权谋大剧首播即爆，节奏口碑双在线", tag: "影视剧", hot: 92, time: "2 小时前", summary: "开画首周播放量破 8 亿，服化道与权谋线获普遍好评，被认为提前锁定年度剧王候选。" },
    { title: "都市情感剧大结局催泪收官，词条冲上热搜", tag: "影视剧", hot: 88, time: "5 小时前", summary: "开放式结局引发全网二创与讨论，主演回应角色的长文转发破十万。" },
    { title: "悬疑电影点映口碑两极，片方急宣物料", tag: "影视剧", hot: 79, time: "1 天前", summary: "上映前提前场观影反馈分化，片方加推幕后特辑试图稳定观众预期。" },
    { title: "老牌经典 IP 宣布重映修复版，情怀刷屏", tag: "影视剧", hot: 71, time: "1 天前", summary: "经典影像 4K 修复版定档重映，引发多代观众集体回忆杀。" },
  ],
  show: [
    { title: "沉浸式推理综艺开播，烧脑程度拉满", tag: "综艺", hot: 90, time: "3 小时前", summary: "全新推理模式嘉宾高能表现登顶话题榜，节目相关片段在短视频平台热传。" },
    { title: "生活观察真人秀回归，治愈感获好评", tag: "综艺", hot: 83, time: "6 小时前", summary: "慢节奏生活观察主打真实陪伴，温馨互动让观众直呼被治愈。" },
    { title: "音乐竞技节目选手互选名场面引爆话题", tag: "综艺", hot: 76, time: "1 天前", summary: "选手选人环节反转连连，导师点评金句频出，段子手纷纷下场。" },
    { title: "户外闯关综艺冒险升级，飞行嘉宾看点十足", tag: "综艺", hot: 68, time: "1 天前", summary: "全新关卡加入高空挑战，飞行嘉宾艺能感爆棚，正片未播预告先火。" },
  ],
  music: [
    { title: "人气乐队发布周年纪念单曲，半小时破百万", tag: "音乐", hot: 89, time: "4 小时前", summary: "乐队时隔一年回归，复古曲风搭配真挚歌词，首小时播放量表现亮眼。" },
    { title: "独立音乐人新专辑口碑封神，乐评人集体安利", tag: "音乐", hot: 82, time: "8 小时前", summary: "概念专辑完整度极高，多元曲风与主题深度获得专业乐评一致好评。" },
    { title: "巡回演唱会官宣加场，售票平台一度卡顿", tag: "音乐", hot: 74, time: "1 天前", summary: "热门歌手巡演因抢票火爆宣布多个城市加场，黄牛票价应声水涨船高。" },
    { title: "OST 大战白热化，热剧主题曲接连上线", tag: "音乐", hot: 66, time: "2 天前", summary: "多部热播剧配乐陆续发布，歌手跨界献声，影视与音乐话题深度联动。" },
  ],
  business: [
    { title: "顶流官宣国民品牌全球代言，海报刷屏", tag: "商业", hot: 86, time: "6 小时前", summary: "官宣三分钟官博转发破纪录，品牌天猫旗舰店访问量激增数倍。" },
    { title: "演员自创茶饮品牌开放加盟，网友热议", tag: "商业", hot: 78, time: "1 天前", summary: "明星副业再添新赛道，产品定价与运营模式成为讨论焦点。" },
    { title: "时尚奢侈品牌联名款秒罄，二手溢价翻倍", tag: "商业", hot: 70, time: "1 天前", summary: "限时联名系列上线即售罄，二级市场价格走高，社交平台晒单刷屏。" },
    { title: "综艺金主换新，定制中插引观众二创", tag: "商业", hot: 62, time: "2 天前", summary: "头部综艺广告主更替，魔性中插广告被网友玩出各种二创梗。" },
  ],
  sports: [
    { title: "人气国手伤愈复出，首秀表现引爆全场", tag: "体坛", hot: 84, time: "5 小时前", summary: "久别赛场的人气选手满血归来，关键回合硬核表现点燃球迷热情。" },
    { title: "冠军教头加盟豪门，签约现场大排场", tag: "体坛", hot: 77, time: "1 天前", summary: "重磅教练转会尘埃落定，俱乐部官宣海报与发布会细节被逐帧解读。" },
    { title: "天才新星一鸣惊人，入选最佳阵容", tag: "体坛", hot: 69, time: "2 天前", summary: "初登顶级赛场的年轻新秀表现惊艳，教练组对其未来寄予厚望。" },
    { title: "城市马拉松万人开跑，明星跑团现身", tag: "体坛", hot: 61, time: "2 天前", summary: "周末城市马拉松热度高涨，多位明星跑者顺利完赛带动全民健身话题。" },
  ],
};

export const timeline = [
  { date: "09.08", week: "周二", title: "爆款续集正式官宣，定档海报同步释出", type: "官宣", text: "万众期待的续作尘埃落定，原班人马全员回归，首支预告点击量一晚破千万。" },
  { date: "09.06", week: "周六", title: "年度音乐节阵容公开，预售票瞬间售罄", type: "音乐", text: "重磅阵容公布引发抢票大战，主办方临时宣布加开名额与线上直播渠道。" },
  { date: "09.04", week: "周四", title: "人气综艺焕新阵容，争议与期待并存", type: "综艺", text: "老牌综艺新一季阵容大换血，老粉与节目组围绕选人逻辑展开多轮讨论。" },
  { date: "09.02", week: "周二", title: "影星跨界品牌官宣，代言版图再扩张", type: "商业", text: "当红演员解锁全新商务板块，双方合作官宣内容刷屏各大社交平台。" },
  { date: "08.31", week: "周一", title: "球界重磅主帅敲定去向，引援进入冲刺", type: "体坛", text: "休赛期最大悬念揭晓，新帅战术思路曝光，球迷为即将到来的赛程预热。" },
  { date: "08.29", week: "周六", title: "热播剧大结局收官，系列续作同步埋线", type: "影视", text: "现象级热剧正式收官，彩蛋为续作埋下伏笔，二创热度持续高涨。" },
];

export const featured = [
  {
    title: "顶流跨界全图谱：从作品到商务的涨粉密码",
    cat: "深度盘点",
    reads: "12.4 万",
    desc: "拆解顶流艺人如何通过作品、综艺与商务三线联动维持超高话题度，梳理其粉丝运营与内容出圈的关键节点。",
    image: "https://readdy.ai/api/search-image?query=Modern%20cinema%20stage%20with%20golden%20spotlights%20and%20neon%20rings%2C%20abstract%20entertainment%20industry%20concept%20art%2C%20warm%20orange%20and%20rose%20tones%2C%20clean%20editorial%20illustration&width=800&height=500&seq=feature-cross-01&orientation=landscape"
  },
  {
    title: "这一届观众到底在为什么买单？口碑与热度解码",
    cat: "趋势观察",
    reads: "9.8 万",
    desc: "从本月多部剧综的市场反馈出发，拆解当下观众的内容审美偏好，回答口碑剧为何逆袭、话题剧为何争议不断。",
    image: "https://readdy.ai/api/search-image?query=Audience%20silhouette%20watching%20glowing%20screen%20in%20cinema%2C%20warm%20ambient%20light%2C%20abstract%20media%20consumption%20concept%2C%20orange%20and%20cream%20palette%2C%20modern%20editorial%20art&width=800&height=500&seq=feature-viewer-02&orientation=landscape"
  },
  {
    title: "品牌 x 明星：联名爆款背后的商业逻辑",
    cat: "商业内参",
    reads: "8.2 万",
    desc: "复盘本月现象级联名与代言更替案例，探讨品牌如何挑选契合代言人，明星商务为何能撬动真金白银的关注度。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20product%20collaboration%20display%20on%20warm%20amber%20background%2C%20luxury%20brand%20campaign%20still%20life%2C%20soft%20studio%20light%2C%20minimal%20editorial%20product%20photography&width=800&height=500&seq=feature-brand-03&orientation=landscape"
  },
];

export const faqs = [
  {
    q: "本月大瓜榜单多久更新一次？",
    a: "热度榜单每 6 小时自动刷新一次，综合全网多平台的热搜、讨论量、转发量等维度加权计算，确保反映最新的大盘热度走势，重要突发事件会即时补录并置顶提醒。",
  },
  {
    q: "上榜事件是如何筛选的？",
    a: "我们会综合事件的全网提及量、讨论增速、传播时长与平台覆盖度进行判定，再结合人工编辑校验，优先收录影视、综艺、音乐、商业与体坛等领域真正具有广泛讨论度的热点。",
  },
  {
    q: "分类吃瓜里的内容与榜单有什么区别？",
    a: "榜单侧重横向比拼当前热度排名，让你一眼看清谁最火；分类吃瓜则按领域纵向呈现，方便你按兴趣深挖某个方向（比如只看音乐圈）近期发生了哪些大事。",
  },
  {
    q: "全记录时间轴有什么用？",
    a: "时间轴按时间倒序完整还原本月发生过的重大事件与关键节点，方便你复盘事件的完整脉络，即使中途没跟进也不会漏掉重要的来龙去脉。",
  },
  {
    q: "我可以投稿或补充遗漏的事件吗？",
    a: "当然可以。如果你发现了我们尚未收录的优质热点，欢迎通过页脚的投稿表单或联系邮箱反馈，经编辑核实后会尽快补充进对应榜单与分类。",
  },
  {
    q: "内容来源可靠吗？如何看待同一条事件的不同说法？",
    a: "我们会优先采用官方公告与多方交叉信源，并在同一事件出现多种说法时并列呈现官方口径与各方回应，帮助你在吃瓜时不偏听偏信、看清全貌。",
  },
];

export const testimonials = [
  { quote: "以前吃瓜要翻十几个账号，现在每天下班看一次榜单就全掌握了，省心。", name: "追剧不加班的雯雯", role: "影视区深度用户" },
  { quote: "时间轴做得很扎实，好多我没跟上的事件顺着看一遍就懂了来龙去脉。", name: "晚风不吹灯", role: "综艺爱好者" },
  { quote: "分类很贴心，我只关心音乐圈，切到对应栏目就能精准吃到圈内瓜。", name: "耳机不离身的小周", role: "音乐博主" },
  { quote: "更新很勤快，突发事件基本当天就能上榜，节奏抓得很准。", name: "快乐吃瓜群众老白", role: "每日访问用户" },
];

export const footerLinks = {
  快速导航: [
    { label: "本月总览", href: "#overview" },
    { label: "热度榜单", href: "#rank" },
    { label: "分类吃瓜", href: "#feed" },
    { label: "全记录", href: "#timeline" },
  ],
  更多内容: [
    { label: "热门专题", href: "#featured" },
    { label: "吃瓜指南", href: "#faq" },
    { label: "关于我们", href: "#about" },
    { label: "投稿联系", href: "#contact" },
  ],
};